/**
 * Manipula erros de forma consistente.
 * Se o erro for uma instância de Error, loga a mensagem de erro.
 * Caso contrário, loga o erro genérico.
 * @param error O erro a ser tratado.
 */

import errorToast from '@/toasts/errorToast'

function handleError(error: unknown) {
  const toast = useToast()

  if (error.details != null) {
    errorToast({ toast, description: error.details, duration: 2000 })
  }
}

export default handleError
